import { Injectable } from '@angular/core';
import { RetailerStatus } from '@shared/entities/entities';

@Injectable({
  providedIn: 'root',
})
export class RetailerStatusesService {
  private readonly statuses: readonly RetailerStatus[];

  constructor() {
    this.statuses = [
      {
        code: 1,
        description: 'Enrolled',
      },
      {
        code: 2,
        description: 'Not Enrolled',
      },
      {
        code: 3,
        description: 'Pending',
      },
    ];
  }

  getStatuses(): readonly RetailerStatus[] {
    return this.statuses;
  }

  getDescriptionFromCode(code: number): string | undefined {
    const status = this.statuses.filter((s) => s.code === code)[0];
    return status?.description;
  }
}
